<div class="modal-body" *ngIf="loading">
    <div class="d-flex align-items-center">
        <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
        <span class="ml-2">Please wait while loading Report details....</span>
    </div>
</div>
<div *ngIf="!isExternalReport">
    <div class="modal-body" *ngIf="!loading && demographData.length === 0 && !isExternalReport">
        <div class="d-flex justify-content-center">
            <div class="no-data-container">
                <img class="mt-1" width="350" src="assets/images/no-data-2.png" alt="No Data" />
                <h4 class="mt-1">No Report Data found.Nothing to show you.</h4>
            </div>
        </div>
    </div>

    <div Id="invoiceId" *ngIf="!loading && demographData.length > 0" class="d-flex justify-content-between pb-2 pt-0 w-100 flex-wrap">
        <div class="report position-relative">

            <table class="w-100">

                <thead>
                    <tr>
                        <td>

                            <div class="page-header-space">
                                <div>
                                    <div class="w-100">
                                        <div *ngIf="isPrintLogo" class="text-center pb-1 border-bottom2px">
                                            <img [src]="headerUrl != null ? headerUrl : careAxesUrl" alt="Careaxes" class="reportlogo"  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>
                            <!--*** CONTENT GOES HERE ***-->
                            <div class="page">
                                <div id="print-content">
                                    <div id="dataContainer" class="dataContainerheight">
                                        <div class="w-100 reportborder" >
                                            <h3 class="headingText col-12 reportHeading" colspan="5">
                                                Laboratory Report
                                            </h3>
                                            <div class="overflow-auto">
                                                <table width="100%" class="heading1">
                                                    <tr class="vertical-align-top">
                                                        <th>
                                                            <h5 class="white-space-nowrap" *ngIf="demographData[0].patientName">Patient Name</h5>
                                                        </th>
                                                        <td class="d-flex">
                                                            <span class="mr-5">: </span>
                                                            <span class="text-capitalize" *ngIf="demographData[0].patientName" [textContent]="demographData[0].patientName"></span>
                                                        </td>
                                                        <th>
                                                            UMR No
                                                        </th>
                                                        <td class="white-space-nowrap">
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].umrNo || '-----'"></span>
                                                        </td>
                                                    </tr>
                                                    <tr class="vertical-align-top">
                                                        <th>
                                                            Age/Gender
                                                        </th>
                                                        <td>
                                                            <div class="d-flex">
                                                                <span class="mr-5">: </span>
                                                                <div>
                                                                    <span *ngIf="!demographData[0].dateOfBirth">{{demographData[0].age}} Year &nbsp;0 Month&nbsp;0Days </span>
                                                                    <span *ngIf="demographData[0].dateOfBirth">{{age.year}} Year &nbsp;{{age.month}} Month&nbsp;{{age.day}} Days </span>
                                                                    <span *ngIf="demographData[0].gender">&nbsp;/</span>
                                                                    <span *ngIf="demographData[0].gender" [textContent]="demographData[0].gender || '----'"></span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <th>
                                                            Invoice Date
                                                        </th>
                                                        <td class="white-space-nowrap">
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].bookedDate | date:'dd/MM/yyyy, h:mm a'"></span>
                                                        </td>
                                                    </tr>
                                                    <tr class="vertical-align-top">
                                                        <th>
                                                            Location
                                                        </th>
                                                        <td>
                                                            <span class="mr-5">: </span>
                                                            <span class="text-capitalize" [textContent]="demographData[0].fromLocation"></span>
                                                        </td>
                                                        <th class="white-space-nowrap">
                                                            Requisition No
                                                        </th>
                                                        <td class="white-space-nowrap">
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].requisitionNumber"></span>
                                                        </td>
                                                    </tr>
                                                    <tr class="vertical-align-top">
                                                        <th>
                                                            Patient Type
                                                        </th>
                                                        <td>
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].bookingType"></span>
                                                        </td>
                                                        <th class="white-space-nowrap">
                                                            Collected Date
                                                        </th>
                                                        <td>
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].collectionDate | date:'dd/MM/yyyy, h:mm a'"></span>
                                                        </td>
                                                    </tr>
                                                    <tr class="vertical-align-top">
                                                        <th>
                                                            Doctor Name
                                                        </th>
                                                        <td class="d-flex">
                                                            <span class="mr-5">: </span>
                                                            <span class="text-capitalize" [textContent]="demographData[0].doctorName || '------'"></span>
                                                        </td>
                                                        <th>
                                                            Received Date
                                                        </th>
                                                        <td>
                                                            <span class="mr-5">: </span>
                                                            <span [textContent]="demographData[0].receivedDate | date:'dd/MM/yyyy, h:mm a'"></span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                        <div class=" intermbackgroundOfwaterMark"   *ngIf="reportSignatures.length == 0">
                                            <h6 class=" intermtextOfwaterMark watermarkfontsize">Interim Report </h6>
                                        </div>
                                        <div class="col-12 p-0 mt-2 reportborder" >
                                            <div *ngFor="let template of reports.templates;index as t;">
                                                <div class="d-flex justify-content-center">
                                                    <h4 class="underline">{{template.templateName}}</h4>
                                                </div>
                                                <div>
                                                    <div class="overflow-auto textOfEveryVw">
                                                        <table width="100%">
                                                            <thead>
                                                                <tr class="vertical-align-top">
                                                                    <th>Test Name</th>
                                                                    <th>Result</th>
                                                                    <th>Biological Reference Range</th>
                                                                    <th>Unit</th>
                                                                    <th>Method</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let parameter of template.parameters;index as p;">
                                                                    <td>
                                                                        <span [textContent]="parameter.parameterName || '-----'" *ngIf="parameter.type == 'Regular'"></span>
                                                                        <h5 class="mb-0 text-capitalize text-primary" [textContent]="parameter.parameterName || '-----'" *ngIf="parameter.type != 'Regular' && parameter.observedValue == null"></h5>
                                                                        <span [textContent]="parameter.antibioticName || '-----'" *ngIf="parameter.type != 'Regular' && parameter.observedValue != null"></span>
                                                                    </td>
                                                                    <td>
                                                                        <span [ngClass]="{'font-weight-bolder' : parameter.isBold}" [textContent]="parameter.observedValue || '-----'" *ngIf=" parameter.observedValue != null"></span>&nbsp;
                                                                        <span [textContent]="parameter.showText"></span>
                                                                    </td>
                                                                    <td>
                                                                        <span *ngIf="parameter.referenceOutput === 'numeric' && (parameter.text === null || parameter.text === undefined) && parameter.type == 'Regular'">
                                                                            {{parameter.selected.minValue}}-{{parameter.selected.maxValue}}
                                                                        </span>
                                                                        <span *ngIf="parameter.text &&parameter.type == 'Regular'">
                                                                            <span [innerHTML]="parameter.text"></span>
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span *ngIf="parameter.selected && parameter.selected != undefined && parameter.selected.unitName != undefined && parameter.selected.unitName != null && parameter.type == 'Regular'">
                                                                            {{parameter.selected.unitName || ''}}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span [textContent]="parameter.methodName || ' '"></span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="w-100" *ngIf="template.isMethod || template.isInterpretation">
                                                    <div class="p-0">
                                                        <div class="d-flex flex-wrap">
                                                            <div class="col-12 p-0" *ngIf="template.isMethod">
                                                                <div class="form-group">
                                                                    <label class="mb-0 headingText1 font-weight-bold pl-4">Method</label>
                                                                    <div [innerHTML]="template.methodText"></div>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 p-0" *ngIf="template.isInterpretation">
                                                                <div class="form-group">
                                                                    <label class="mb-0 headingText1 font-weight-bold pl-4">Interpretation/Result</label>
                                                                    <div [innerHTML]="template.interpretationText"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12" *ngIf="reportData">
                                            <div class="heading1 pl-1 pr-1" *ngIf="!loading && checkExternal && checkExternal.reportUrl">
                                                <pdf-viewer [src]="reportData['changingThisBreaksApplicationSecurity']"
                                                            [render-text]="true"
                                                            [autoresize]="true"
                                                            [original-size]="false"
                                                            [fit-to-page]="false"
                                                            (on-progress)="onProgress($event)"
                                                           >
                                                </pdf-viewer>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="d-flex justify-content-center">
                                                <p>--End Of Report--</p>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="align-items-baseline d-flex flex-wrap justify-content-between mb-1 ml-lg-4 mr-lg-5">
                                                <div class="align-items-center d-flex gap">
                                                    <div>
                                                        <qrcode [qrdata]="QrCode" [width]="150" [errorCorrectionLevel]="'M'" [elementType]="'img'"></qrcode>
                                                    </div>
                                                    <div *ngIf="demographData[0].isNablRequired && demographData[0].nablRequired && nablUrl">
                                                        <img [src]="nablUrl" alt="No Data" class="mt-1" width="100" />
                                                          </div>
                                                </div>
                                                <div class="text-capitalize" *ngFor="let signature of reportSignatures;index as p;">
                                                    <div class="bg-light">
                                                        <img  [src]="safe(signature.signature)" alt="DoctorSignature" class="img-fluid signature">
                                                    </div>
                                                    <h6 class="m-0 headingText1" [textContent]="signature.providerName"></h6>
                                                    <h6 class="m-0 headingText1">{{signature.departmentName}}</h6>
                                                     <h6 class="m-0 headingText1">{{signature.approvedDate | date:'dd/MM/yyyy, h:mm a'}}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <h4 class="border-bottom border-dark border-top topHeading font-weight-bold mb-2 p-1 text-center text-dark">
                                        TERMS AND CONDITIONS FOR LABORATORY TESTING AND REPORTING
                                    </h4>
                                    <div class="d-flex flex-lg-nowrap flex-wrap headingText1 pr-3 text-justify gap" >
                                        <div>
                                            <ul>
                                                <li>
                                                    The reported results are for information and interpretation of the
                                                    referring clinician or other medical professional, who understands
                                                    reporting units, reference ranges and limitation of technologies.
                                                </li>
                                                <li>
                                                    A qualified medical professional should interpret the laboratory
                                                    results and adjuvant information using objective clinical judgment
                                                    and in conjunction with patient presentation, history, and other
                                                    diagnostic evidence.
                                                </li>
                                                <li>
                                                    The laboratory services at Fernandez Hospital (A unit of Fernandez
                                                    Foundation) may outsource certain tests to qualified labs.
                                                </li>
                                                <li>
                                                    Test results depend upon quality of sample and testing method, and
                                                    they may vary from lab-to-lab and/or from time-to-time for the same
                                                    parameters for the same patient. To help maintain sample quality, the
                                                    laboratory specifies criteria for specimen storage in accordance with
                                                    accreditation guidelines and testing methods. For more information,
                                                    please contact the Laboratory Services team.
                                                </li>
                                            </ul>
                                        </div>
                                        <div>
                                            <ul>
                                                <li>
                                                    Specified biological reference ranges encompass 95% confidence
                                                    limits of a given population, which implies test results for healthy
                                                    individuals may fall in the abnormal range. In case of unexpectedly
                                                    abnormal lab results, the lab services team may perform repeat
                                                    analysis, based on Clinician/Client’s request and after due
                                                    investigation.
                                                </li>
                                                <li>
                                                    We assure that we maintain confidentiality of this information.
                                                </li>
                                                <li>
                                                    Fernandez Foundat ion, i ts di rectors, employees and/or
                                                    representatives are not liable for claims of damages incurred by any
                                                    person, including the patient as a result of interpretation of lab reports.
                                                    Financial or monetary claims are subject to approval by the
                                                    management of Fernandez Foundation and shall not exceed the
                                                    stipulated test cost under any circumstances.
                                                </li>
                                                <li>
                                                    All claims are subject to the jurisdiction of Hyderabad (TS) India.
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td>
                            <!--place holder for the fixed-position footer-->
                            <div class="page-footer-space"></div>
                        </td>
                    </tr>
                </tfoot>

            </table>

            <div class="page-footer">
                <div class="border-top border-dark pb-1 px-1 left-0 right-0" [ngStyle]="{'background-color': (isPrintLogo && footerUrl != null) ? 'white':'#dddddd'}" style="background-color: #dddddd; ">
                    <div *ngIf="isPrintLogo && footerUrl != null" class="text-center p-1">
                        <img [src]="footerUrl" alt="Careaxes" class="reportFooter"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="isExternalReport">
    <div class="modal-body" *ngIf="isExternalLoading">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while rendering pdf....</span>
        </div>
    </div>
    <div class="heading1 pl-1 pr-1" Id="invoiceId" *ngIf="!loading && reportData">
        <div class="d-block d-flex justify-content-end mt-1">
            <button class="btn btn-sm btn-outline-info" type="button" (click)="onPrintPdf()"><i class="mdi mdi-printer mr-1"></i> print</button>
        </div>
        <pdf-viewer [src]="reportData['changingThisBreaksApplicationSecurity']"
                    [render-text]="true"
                    [autoresize]="true"
                    [original-size]="false"
                    [fit-to-page]="false"
                    (on-progress)="onProgress($event)"
                    class="pdf">
        </pdf-viewer>
    </div>
</div>

